import Calendario from "../../ComponentesGlobales/Calendario";
import SelectorClientes from "../../ComponentesGlobales/SelectorClientes";
import { useStoreDespachos } from "./useStoreDespachos";

const DespachoTab1 = () => {
    const Fecha = useStoreDespachos((state) => state.Fecha);
    const Numero = useStoreDespachos((state) => state.Numero);
    const Cliente = useStoreDespachos((state) => state.Cliente);
    const ListaClientes = useStoreDespachos((state) => state.ListaClientes);
    const BuscandoClientes = useStoreDespachos((state) => state.BuscandoClientes);
    const ErrorClientes = useStoreDespachos((state) => state.ErrorClientes);
    const FechasConDespachos = useStoreDespachos((s) => s.FechasConDespachos);

    return (
        <div className="desp-bloque-form" style={{ position: 'relative' }}>
            <div className="bloque-cabecera">
                <h4 className="ing-subtitulo">Destino</h4>
                <div className="btns">
                    <button className="btn-limpiar" style={{
                        padding: '0px',
                        position: 'absolute',
                        top: '10px',
                        right: '10px',
                        zIndex: 10
                    }} onClick={useStoreDespachos.getState().limpiezaTotal} title='Limpiar campos'>
                        <i className="pi pi-eraser" aria-hidden="true" /><span>Limpiar</span>
                    </button>
                </div>
            </div>
            <div className="desp-fila-flex">
                <div className="desp-campo" style={{ marginBottom: "20px" }}>
                    <div className="camp-o">
                        <label>Fecha:</label>
                    </div>
                    <Calendario
                        Fecha={Fecha}
                        setFecha={(fecha) => useStoreDespachos.setState({ Fecha: fecha })}
                        highlightedDates={FechasConDespachos}

                    />
                </div>
                <div className="desp-campo" style={{ marginBottom: "20px" }} >
                    <div className="camp-o" >
                        {Numero === "" && (
                            <span className="mensaje-obligatorio">*</span>
                        )}
                        <label>N° Cliente:</label>
                    </div>
                    <input
                        type="number"
                        name="remito"
                        value={Numero}
                        onChange={(e) => useStoreDespachos.setState({ Numero: e.target.value })}
                        placeholder="0001-000001"
                        autoComplete="off"
                    />
                </div>
                <div className="desp-campo">
                    <div className="camp-o">
                        <label>Cliente:</label>
                    </div>
                    <SelectorClientes Lista={ListaClientes} Buscando={BuscandoClientes}
                        Error={ErrorClientes}
                        Reintentar={() => useStoreDespachos.getState().getClientes({ forzar: true })}
                        setValor={(e) => useStoreDespachos.setState({ Cliente: e })}
                        Seleccionado={Cliente} TituloNoSeleccionado={"Nuevo Cliente"}
                    />
                </div>
            </div>
        </div>
    );
};

export default DespachoTab1;
